module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921102649_T.bb867925.jpg";